import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';

/**
 * Collection of possible createEvent payloads
 */
export type TEventState =
  // emptystring else case
  | Record<string, unknown>;

const initialState: TEventState = {};

/**
 * Slice to use with createEvent
 */
export const eventSlice = createSlice({
  name: 'event',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    eventPatch: (state, action: PayloadAction<TEventState>): TEventState => ({
      ...state,
      ...action.payload,
    }),
    eventPut: (_state, action: PayloadAction<TEventState>): TEventState =>
      action.payload,
  },
});

export const { eventPatch, eventPut } = eventSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.plivo.value)`
export const selectEvent = (state: RootState) => state.event;

export const eventReducer = eventSlice.reducer;
